export default class ForgotPasswordRequest{
  public constructor(public email: string) {

  }
}
